import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import CookieService from './services/cookies'
import lodash from './services/lodash'
import http from './services/axios'
import vanilla from './services/vanilla'
import helpers from './services/helpers'

import {
    LOADING_PRISTINE,
    LOADING_STARTED,
    LOADING_COMPLETED_FAILURE,
    LOADING_COMPLETED_SUCCESS,
    LOGIN_COOKIE_KEY,
    GET_SESSION_TOKEN,
    INIT_SESSION_TOKEN,
    SET_SESSION_TOKEN,
    SET_SPACE_METADATA,
    SET_CURRENT_USER,
    SET_SPACE_CONTENT_TYPES,
    SET_CONTENT_DASHBOARD_STATE,
    SET_CONTENT_DASHBOARD_DATA_TABLE_PAGINATION_STATE,
    GET_CONTENT_DASHBOARD_DATA_TABLE_PAGINATION_STATE,
    SET_SPACE_CONTENT,
    LOAD_SPACE_METADATA,
    LOAD_CURRENT_USER,
    LOAD_SPACE_CONTENT_TYPES,
    LOAD_SPACE_LOCALIZATIONS,
    LOAD_SPACE_CONTENT,
    LOAD_SPACE_CONTENT_ARCHIVED,
    UPDATE_ENTRY,
    UPDATE_ARRAY_OF_ENTRIES,
    SET_CONTENT_DASHBOARD_STATE_AND_RELOAD,
    PUSH_NESTED_CREATION_OBJECT,
    REMOVE_NESTED_CREATION_STACK_TOP,
    GET_NESTED_CREATION_STACK_TOP,
    SET_REFERENCE_NESTED_CREATION_OBJECT_STACK_TOP,
    LOAD_SPACE_ASSET_CONTENT_TYPE,
    PURGE_SPACE_STATE_FOR_LOGOUT,
    UNSET_SPACE_CONTENT,
    RESET_NESTED_CREATION_STACK,
    GET_FILTERED_ENTRIES,
    PUSH_REFERENCE_FILTER_ENTRIES,
    SPLICE_REFERENCE_FILTER_ENTRIES,
    CLEAR_REFERENCE_FILTER_ENTRIES,
    GET_FILTERED_ENTRIES_REFERENCE_FIELD_CHOOSE_EXISTING,
    SET_REFERENCE_FIELD_CONTENT_TYPE,
    SET_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_TERM,
    PUSH_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_ENTRIES,
    SPLICE_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_ENTRIES,
    CLEAR_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_ENTRIES,
    SET_REORDER_CONTENT_BACKING_ARRAY,
    PUSH_REORDER_CONTENT_FILTER_ENTRIES,
    SPLICE_REORDER_CONTENT_FILTER_ENTRIES,
    CLEAR_REORDER_CONTENT_FILTER_ENTRIES,
    GET_FILTERED_ENTRIES_REORDER_CONTENT,
    SET_REORDER_CONTENT_IDENTIFIER,
    SET_REORDER_CONTENT_BACKING_ARRAY_AND_SORT,
    GET_CONTENT_TYPE_IDENTIFIER_TO_CONTENT_TYPE_HASH,
    GET_SPACE_PROPERTY_UI_DASHBOARD_CONTENT_SORT_MAP,
    SORT_DIRECTION_DESCENDING,
    A_SET_CONTENT_DASHBOARD_TABLE_CONFIG_FROM_SPACE_PROPERTY,
    GET_CONTENT_DASHBOARD_DEFAULT_TABLE_CONFIG,
    LOAD_SPACE_PROPERTIES,
} from './services/constants'

import {mediaStoreModule} from "./store_modules/mediaStore"
import {localizationStoreModule} from "./store_modules/localizationStoreModule"
import {archiveModule} from "./store_modules/archiveStore"
import {usersModule} from "./store_modules/users"
import {propertiesModule} from "./store_modules/propertiesModule"

const store = new Vuex.Store({
    modules: {
        media: mediaStoreModule,
        locale: localizationStoreModule,
        archive: archiveModule,
        usersModule,
        propertiesModule
    },
    state: {
        sessionToken: null,
        currentUser: null,
        spaceMetadata: null,
        spaceContentTypes: [],
        contentDashboardState: {
            selectedContentType: '',
            showArchived: false,
            paginationSync: {
                sortBy: 'name',
                descending: false,
                rowsPerPage: 25,
                // rowsPerPage: Number.MAX_SAFE_INTEGER,
            },
            searchFilterTerm: '',
            loadingState: LOADING_PRISTINE,
            referenceFilterEntries: [],
        },
        spaceContent: {},
        nestedCreateObjectStack: [],
        referenceFieldState: {
            contentTypeIdentifier: '',
            chooseExistingFilterTerm: '',
            referenceFilterEntries: [],
        },
        reorderContent: {
            backingArray: [],
            referenceFilterEntries: [],
            contentTypeIdentifier: '',
        },


    },
    getters: {
        [GET_SESSION_TOKEN]: (state) => {
            return state.sessionToken
        },
        [GET_NESTED_CREATION_STACK_TOP]: (state) => {
            return state.nestedCreateObjectStack[state.nestedCreateObjectStack.length - 1]
        },
        [GET_CONTENT_DASHBOARD_DATA_TABLE_PAGINATION_STATE]: (state) => {
            return lodash.cloneDeep(state.contentDashboardState.paginationSync)
        },
        [GET_CONTENT_TYPE_IDENTIFIER_TO_CONTENT_TYPE_HASH]: (state) => {
            const hash = {}
            state.spaceContentTypes.forEach(contentType => {
                hash[contentType.identifier] = contentType
            })
            return hash
        },
        [GET_CONTENT_DASHBOARD_DEFAULT_TABLE_CONFIG]: () => {
            return {
                sortBy: 'name',
                descending: false,
                // rowsPerPage: 25,
                // rowsPerPage: Number.MAX_SAFE_INTEGER,
            }
        },
        [GET_FILTERED_ENTRIES]: (state) => {
            const entries = state.contentDashboardState.showArchived ?
                state.archive.spaceContent[state.contentDashboardState.selectedContentType]
                : state.spaceContent[state.contentDashboardState.selectedContentType]
            if (entries) {
                const reducedBySearchTerm = helpers.searchEntries(entries, state.contentDashboardState.searchFilterTerm)
                const reducedByReferenceTerms = helpers.filterEntriesByReferenceEntries(reducedBySearchTerm, state.contentDashboardState.referenceFilterEntries)
                return reducedByReferenceTerms
            }
            return []
        },
        [GET_FILTERED_ENTRIES_REFERENCE_FIELD_CHOOSE_EXISTING]: (state) => {
            const entries = state.spaceContent[state.referenceFieldState.contentTypeIdentifier]
            if (entries) {
                const reducedBySearchTerm = helpers.searchEntries(entries, state.referenceFieldState.chooseExistingFilterTerm)
                const reducedByReferenceTerms = helpers.filterEntriesByReferenceEntries(reducedBySearchTerm, state.referenceFieldState.referenceFilterEntries)
                return reducedByReferenceTerms
            }
            return []
        },
        [GET_FILTERED_ENTRIES_REORDER_CONTENT]: (state) => {
            const entries = state.reorderContent.backingArray
            if (entries) {
                return helpers.filterEntriesByReferenceEntries(entries, state.reorderContent.referenceFilterEntries)
            }
            return []
        },

    },
    mutations: {
        [INIT_SESSION_TOKEN]: (state) => {
            state.sessionToken = CookieService.getSessionCookie();
        },
        [SET_SESSION_TOKEN]: (state, payload) => {
            state.sessionToken = payload[LOGIN_COOKIE_KEY]
            if (state.sessionToken) {
                CookieService.setSessionCookie(payload[LOGIN_COOKIE_KEY])
            } else {
                CookieService.removeSessionCookie()
            }
        },
        [SET_SPACE_METADATA]: (state, payload) => {
            state.spaceMetadata = payload
            CookieService.setCookiePath(state.spaceMetadata.identifier)
        },
        [SET_CURRENT_USER]: (state, payload) => {
            state.currentUser = payload
        },
        [SET_SPACE_CONTENT_TYPES]: (state, payload) => {
            state.spaceContentTypes = payload
        },
        [SET_CONTENT_DASHBOARD_STATE]: (state, payload) => {
            state.contentDashboardState = lodash.merge(state.contentDashboardState, payload)
        },
        [PUSH_REFERENCE_FILTER_ENTRIES]: (state, payload) => {
            state.contentDashboardState.referenceFilterEntries.push(payload)
        },
        [SPLICE_REFERENCE_FILTER_ENTRIES]: (state, index) => {
            state.contentDashboardState.referenceFilterEntries.splice(index, 1)
        },
        [CLEAR_REFERENCE_FILTER_ENTRIES]: (state) => {
            state.contentDashboardState.referenceFilterEntries = []
        },
        [SET_CONTENT_DASHBOARD_DATA_TABLE_PAGINATION_STATE]: (state, payload) => {
            state.contentDashboardState.paginationSync =
                lodash.cloneDeep(
                    // lodash.pick(
                    //     ['sortBy', 'descending'],
                    payload
                    // )
                )
        },
        [SET_REFERENCE_FIELD_CONTENT_TYPE]: (state, identifier) => {
            state.referenceFieldState.contentTypeIdentifier = identifier
        },
        [SET_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_TERM]: (state, identifier) => {
            state.referenceFieldState.chooseExistingFilterTerm = identifier
        },
        [PUSH_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_ENTRIES]: (state, payload) => {
            state.referenceFieldState.referenceFilterEntries.push(payload)
        },
        [SPLICE_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_ENTRIES]: (state, index) => {
            state.referenceFieldState.referenceFilterEntries.splice(index, 1)
        },
        [CLEAR_REFERENCE_FIELD_CHOOSE_EXISTING_FILTER_ENTRIES]: (state) => {
            state.referenceFieldState.referenceFilterEntries = []
        },
        [PUSH_REORDER_CONTENT_FILTER_ENTRIES]: (state, payload) => {
            state.reorderContent.referenceFilterEntries.push(payload)
        },
        [SPLICE_REORDER_CONTENT_FILTER_ENTRIES]: (state, index) => {
            state.reorderContent.referenceFilterEntries.splice(index, 1)
        },
        [CLEAR_REORDER_CONTENT_FILTER_ENTRIES]: (state) => {
            state.reorderContent.referenceFilterEntries = []
        },
        [SET_SPACE_CONTENT]: (state, payload) => {
            if (!state.spaceContent[payload.identifier]) {
                Vue.set(state.spaceContent, payload.identifier, payload.data)
            } else {
                state.spaceContent[payload.identifier] = payload.data;
            }
        },
        [UNSET_SPACE_CONTENT]: (state) => {
            state.spaceContent = {}
        },
        [PUSH_NESTED_CREATION_OBJECT]: (state, payload) => {
            state.nestedCreateObjectStack.push(lodash.cloneDeep(payload))
        },
        [SET_REFERENCE_NESTED_CREATION_OBJECT_STACK_TOP]: (state, payload) => {
            const topOfStack = state.nestedCreateObjectStack[state.nestedCreateObjectStack.length - 1]
            const contentTypeIdentifier = topOfStack.routeSnapshot.params.contentTypeIdentifier
            const selectedFieldIdentifier = topOfStack.selectedField

            //get the content type of the identifier
            const contentType = state.spaceContentTypes.find(contentType => {
                return contentType.identifier === contentTypeIdentifier
            })
            if (contentType) {
                // get all references of that type
                contentType.fields.filter(field => {
                    return field.referenceType
                        && field.referenceType === topOfStack.contentTypeIdentifier
                        && field.identifier === selectedFieldIdentifier
                }).forEach(field => {
                    topOfStack.formModel[field.identifier].value = payload.id
                })
            }
        },
        [REMOVE_NESTED_CREATION_STACK_TOP]: (state) => {
            state.nestedCreateObjectStack.pop()
        },
        [RESET_NESTED_CREATION_STACK]: (state) => {
            state.nestedCreateObjectStack = []
        },
        [SET_REORDER_CONTENT_BACKING_ARRAY]: (state, payload) => {
            state.reorderContent.backingArray = payload
        },
        [SET_REORDER_CONTENT_BACKING_ARRAY_AND_SORT]: (state, payload) => {
            state.reorderContent.backingArray = payload
            state.reorderContent.backingArray.sort(helpers.orderedEntrySort)
        },
        [SET_REORDER_CONTENT_IDENTIFIER]: (state, payload) => {
            state.reorderContent.contentTypeIdentifier = payload
        },

    },
    actions: {
        async [LOAD_SPACE_METADATA](context, payload) {
            try {
                await http.get(`api/management/spaces/${payload.spaceIdentifier}`).then(results => {
                    context.commit(SET_SPACE_METADATA, results.data);
                    vanilla.setDocumentTitle(context.state.spaceMetadata.name)
                })
                if (context.state.sessionToken) {
                    const proms0 = []
                    proms0.push(context.dispatch(LOAD_CURRENT_USER))
                    proms0.push(context.dispatch(LOAD_SPACE_PROPERTIES))
                    await Promise.all(proms0)
                    context.dispatch(LOAD_SPACE_CONTENT_TYPES)
                    context.dispatch(LOAD_SPACE_ASSET_CONTENT_TYPE)
                    context.dispatch(LOAD_SPACE_LOCALIZATIONS)
                }
            } catch (err) {
                console.log(err)
            }
        },
        [LOAD_CURRENT_USER]: (context) => {
            http.get(`api/management/spaces/${context.state.spaceMetadata.id}/users/current`).then(results => {
                context.commit(SET_CURRENT_USER, results.data);
            }).catch(err => {
                console.log(err)
            })
        },
        async [LOAD_SPACE_CONTENT_TYPES](context) {
            try {
                const results = await http.get(`api/management/spaces/${context.state.spaceMetadata.id}/content-types`)
                context.commit(SET_SPACE_CONTENT_TYPES, results.data);
                if (results.data.length > 0) {
                    let initialIdentifier = context.rootState.propertiesModule.uiContentDashboardDefault
                    if (!initialIdentifier) {
                        initialIdentifier = results.data[0].identifier
                    }
                    context.commit(SET_CONTENT_DASHBOARD_STATE, {
                        selectedContentType: initialIdentifier,
                    });
                    context.dispatch(A_SET_CONTENT_DASHBOARD_TABLE_CONFIG_FROM_SPACE_PROPERTY)
                    await context.dispatch(LOAD_SPACE_CONTENT, {identifier: initialIdentifier})
                }
            } catch (err) {
                console.log(err)
            }
        },
        [LOAD_SPACE_CONTENT]: (context, payload) => {
            context.commit(SET_SPACE_CONTENT, {
                identifier: payload.identifier,
                data: context.state.spaceContent[payload.identifier],
            });

            let url = ''
            let requestPayload = {
                params: {}
            }
            if (payload.identifier === 'all') {
                url = `api/management/spaces/${context.state.spaceMetadata.id}/entries`
            } else {
                url = `api/management/spaces/${context.state.spaceMetadata.id}/entries/${payload.identifier}`
            }

            if (payload.filterRef) {
                // add on query parameters based on filter state
                if (payload.filterRef.showArchived) {
                    requestPayload.params['showArchived'] = true
                }
            }

            context.commit(SET_CONTENT_DASHBOARD_STATE, {
                loadingState: LOADING_STARTED,
            });
            return http.get(url, requestPayload)
                .then(results => {
                    context.commit(SET_CONTENT_DASHBOARD_STATE, {
                        loadingState: LOADING_COMPLETED_SUCCESS,
                    });
                    context.commit(SET_SPACE_CONTENT, {
                        identifier: payload.identifier,
                        data: results.data,
                    });

                    const contentType = context.state.spaceContentTypes.find(contentType => {
                        return contentType.identifier === payload.identifier
                    })
                    if (contentType) {
                        const references = contentType.fields.filter(field => {
                            return !!field.referenceType
                        }).filter((field, index, self) => { // This filter removes duplicates
                            return self.findIndex(field2 => {
                                return field2.referenceType === field.referenceType
                            }) === index
                        }).filter(field => {
                            return !context.state.spaceContent[field.referenceType]
                        })
                        return http.all(references.map(referenceField => {
                            return context.dispatch(LOAD_SPACE_CONTENT, {
                                identifier: referenceField.referenceType,
                            })
                        }))
                    }

                    // return context.dispatch(LOAD_SPACE_CONTENT, {
                    //     identifier: payload.identifier,
                    //     data: context.state.spaceContent[payload.identifier],
                    // })
                }).catch(err => {
                    context.commit(SET_CONTENT_DASHBOARD_STATE, {
                        loadingState: LOADING_COMPLETED_FAILURE,
                    });
                    console.log(payload)
                    console.log(err)
                })
        },
        [UPDATE_ENTRY]: (context, payload) => {
            const flatExitObj = helpers.buildOutgoingObj(payload)
            const spaceId = context.state.spaceMetadata.id
            let locale = context.state.locale.currentLocale === 'default' ? '' : context.state.locale.currentLocale
            if (locale.length > 0) {
                locale += '/'
            }
            const entryId = payload.id
            const contentTypeIdentifier = payload.contentType.identifier
            return http.post(`api/management/spaces/${spaceId}/entries/${locale}${contentTypeIdentifier}/${entryId}`, flatExitObj)
                .catch(err => {
                    console.log(err)
                })
        },
        [UPDATE_ARRAY_OF_ENTRIES]: (context, arrayOfEntries) => {
            let contentTypeIdentifier = ''
            if (arrayOfEntries.length > 0) {
                contentTypeIdentifier = arrayOfEntries[0].contentType.identifier
            }

            return http.all(arrayOfEntries.map(entry => {
                return context.dispatch(UPDATE_ENTRY, entry)
            })).then(responses => {
                if (contentTypeIdentifier) {
                    return context.dispatch(LOAD_SPACE_CONTENT, {
                        identifier: contentTypeIdentifier
                    })
                }
            })
        },
        [A_SET_CONTENT_DASHBOARD_TABLE_CONFIG_FROM_SPACE_PROPERTY]: (context) => {
            const defaultTableConfig = context.getters[GET_CONTENT_DASHBOARD_DEFAULT_TABLE_CONFIG]
            const currentPaginationState = context.getters[GET_CONTENT_DASHBOARD_DATA_TABLE_PAGINATION_STATE]

            const newTableConfig = Object.assign({}, currentPaginationState)
            newTableConfig.sortBy = defaultTableConfig.sortBy
            newTableConfig.descending = defaultTableConfig.descending

            const sortMap = context.getters[GET_SPACE_PROPERTY_UI_DASHBOARD_CONTENT_SORT_MAP]
            if (sortMap) {
                const sortConfig = sortMap[context.state.contentDashboardState.selectedContentType]
                if (sortConfig) {
                    if (sortConfig.key) {
                        newTableConfig.sortBy = sortConfig.key
                    }
                    if (sortConfig.direction) {
                        newTableConfig.descending = sortConfig.direction === SORT_DIRECTION_DESCENDING
                    }
                }
            }
            context.commit(SET_CONTENT_DASHBOARD_DATA_TABLE_PAGINATION_STATE, newTableConfig)
        },
        [SET_CONTENT_DASHBOARD_STATE_AND_RELOAD]: (context, payload) => {
            context.commit(SET_CONTENT_DASHBOARD_STATE, payload);
            context.commit(CLEAR_REFERENCE_FILTER_ENTRIES);
            context.dispatch(A_SET_CONTENT_DASHBOARD_TABLE_CONFIG_FROM_SPACE_PROPERTY)

            const content = context.state.contentDashboardState.showArchived ?
                context.state.archive.spaceContent[context.state.contentDashboardState.selectedContentType] :
                context.state.spaceContent[context.state.contentDashboardState.selectedContentType]
            if (!content) {
                const action = context.state.contentDashboardState.showArchived ?
                    LOAD_SPACE_CONTENT_ARCHIVED : LOAD_SPACE_CONTENT
                return context.dispatch(action, {
                    identifier: context.state.contentDashboardState.selectedContentType,
                    filterRef: context.state.contentDashboardState,
                })
            }
        },
        [PURGE_SPACE_STATE_FOR_LOGOUT]: (context) => {
            context.commit(SET_SESSION_TOKEN, {[LOGIN_COOKIE_KEY]: null})
            // context.commit(SET_SPACE_CONTENT, {
            //     identifier: payload.identifier,
            //     data: [],
            // });
            // let url = ''
            // if (payload.identifier === 'all') {
            //     url = `api/management/spaces/${context.state.spaceMetadata.id}/entries`
            // } else {
            //     url = `api/management/spaces/${context.state.spaceMetadata.id}/entries/${payload.identifier}`
            // }
            // return http.get(url)
            //     .then(results => {
            //         context.commit(SET_SPACE_CONTENT, {
            //             identifier: payload.identifier,
            //             data: results.data,
            //         });
            //     }).catch(err => {
            //         console.log(payload)
            //         console.log(err)
            //     })
        },
    }
})
store.commit(INIT_SESSION_TOKEN);
export default store;






